import type { CollisionDetection } from '@dnd-kit/core';
import { closestCenter, pointerWithin, rectIntersection } from '@dnd-kit/core';

export const getCollapsedNamesAfterFirst = (
  sections: Array<{ name?: string | null }> | undefined,
  keepExpandedName?: string
): string[] =>
  (sections ?? [])
    .slice(1)
    .map((section) => section.name)
    .filter((name): name is string => !!name)
    .filter((name) => name !== keepExpandedName);

export const createFormSectionCollisionDetection = (sortableTypes: readonly string[]): CollisionDetection => {
  const sortableTypeSet = new Set(sortableTypes);

  return (args) => {
    const activeType = args.active.data.current?.type;

    if (typeof activeType === 'string' && sortableTypeSet.has(activeType)) {
      const droppableContainers = args.droppableContainers.filter((container) => container.data.current?.type === activeType);

      return closestCenter({ ...args, droppableContainers });
    }

    const pointerCollisions = pointerWithin(args);

    return pointerCollisions.length > 0 ? pointerCollisions : rectIntersection(args);
  };
};
